import React from 'react';
import { Fragment } from 'react';
import { Row, Col, Container, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Header from '../../../components/header';
import Footer from '../../../components/footer';
import Head from '../../../components/head';
import Item from '../../../components/itens/item'


function OrgaosScreen() {
    return (
        <Fragment>
            <Head titulo="Secretaria Municipal de Educação" />
            <Header />
            <Container>
                <Row xs={1}>
                    <Col xs={{ span: 2, offset: 11 }}>
                        <Link to='/'>
                            <Button type='button' variant='danger'>Voltar</Button>
                        </Link>
                    </Col>
                </Row>
                <br />
                <br />
                <Row xs={1} lg={3}>
                    <Col>
                        <Item
                            titulo={"Escolas e Unidades de Educação"}
                            descricao={"Veja aqui as Unidades Escolares e de Educação no município, seu horário de funcionamento, entre outras informações"}
                            awesome={"faSchool"}
                            link={"../transparencia/orgaos/locais/educacao"}
                            key={2}
                        />
                    </Col>
                    <Col>
                        <Item
                            titulo={"Creche Municipal"}
                            descricao={"Veja aqui as vagas disponíveis, critérios de prioridade e documentos para inscrição da sua criança na Crehe Municipal Zilda Ribeiro Bianchini"}
                            awesome={"faHandsHoldingChild"}
                            link={"educacao/creche"}
                            key={2}
                        />
                    </Col>
                    <Col>
                        <Item
                            titulo={"Pareceres Conclusivos Conselho Municipal do FUNDEB"}
                            descricao={"Veja aqui o pareceres conclusivos do Conselhor Municipal do FUNDEB a respeito da Prestação de contas anuais"}
                            awesome={"faBookOpenReader"}
                            link={"educacao/parecer"}
                            key={2}
                        />
                    </Col>
                    <Col>
                        <Item
                            titulo={"Atas do Conselho Municipal de Educação"}
                            descricao={"Veja aqui as Atas das das reuniões do Conselho Municipal de Educação"}
                            awesome={"faBook"}
                            link={"educacao/atasconselho"}
                            key={2}
                        />
                    </Col>
                    <Col>
                        <Item
                            titulo={"Atas do Conselho Municipal de Alimentação Escolar"}
                            descricao={"Veja aqui as Atas das das reuniões do Conselho Municipal de Alimentação Escolar"}
                            awesome={"faUtensils"}
                            link={"educacao/atasalimentacao"}
                            key={2}
                        />
                    </Col>
                    <Col>
                        <Item
                            titulo={"Plano Municipal de Educação"}
                            descricao={"Veja aqui os Planos Municipais de Educação"}
                            awesome={"faSchoolCircleCheck"}
                            link={"educacao/planomunicipal"}
                            key={2}
                        />
                    </Col>
                    <Col>
                        <Item
                            titulo={"Relatório Anual da Gestão de Educação"}
                            descricao={"Veja aqui os Relatórios Anuais da Gestão de Educação"}
                            awesome={"faClipboard"}
                            link={"educacao/relatorioanual"}
                            key={2}
                        />
                    </Col>
                </Row>
            </Container>
            <Footer />
        </Fragment>
    );
}

export default OrgaosScreen;